import { getCategoryFacets as FacetCategoryQuery } from '@/pages/categories/types/getCategoryFacets'
import { facetCategoryQuery } from '@/pages/categories/queries'

import { apolloClient } from '@/service/apolloClient'

export const getFacetsAllTypeDetail = (categoryIds: number[], categoryFacets: boolean) => {
  return apolloClient.query<FacetCategoryQuery>({
    query: facetCategoryQuery,
    variables: {
      categoryIds: categoryIds,
      offset: 0,
      limit: 0,
      categoryFacets: categoryFacets
    }
  })
}
